
import Clarity from '@microsoft/clarity';
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useParams } from "react-router-dom";
import { CLARITY_PROJECT_ID } from '../../../project_config';
import { api } from "../../../utils/api";
import { LoginHelper } from "../../../utils/LoginHelper";
import Breadcrumb from "../../common/breadcrumb/Breadcrumb";
import Footer from "../../common/footer/Footer";
import Header from "../../common/header/Header";
import SummarySection from "../common/summary/SummarySection";
import PriceSection from "./price/PriceSection";

export default function WorkshopPurchase() {
	Clarity.init(CLARITY_PROJECT_ID);
	const [isDesktop, setIsDesktop] = useState(window.innerWidth > 768);
	const params = useParams();
	const workshopId = params.workshopId;
	const linkDataList = [
		{ label: 'خانه', href: '/' },
		{ label: 'کارگاه‌ها', href: '/workshop_list/' },
		{ label: 'خرید کارگاه', href: '/workshop_purchase/' + workshopId + '/' },
	];
	const [workshop, setWorkshop] = useState(null);
	const [errorMessage, setErrorMessage] = useState('');

	useEffect(() => {
		fetchWorkshop();
	}, []);

	function fetchWorkshop() {
		api.workshopDetail({
			token: LoginHelper.getToken(),
			workshop_id: workshopId,
		}).then((result) => {
			setWorkshop(result);
		}).catch((err) => {
			if (err && err.data) {
				setErrorMessage(err.data.message);
			}
		})
	}

	return (
		<>
			<Helmet>
				<title>خرید کارگاه | همراهتیم</title>
				<meta name="description" content="خرید کارگاه همراهتیم" />
			</Helmet>

			<div className="bg-[#F0F6FC] min-h-screen flex flex-col justify-between">
				<div>
					<Header isDesktop={isDesktop} />
					<div className="bg-white">
						<div className={`${isDesktop ? 'w-[1200px]' : ''} mx-auto`}>
							<Breadcrumb linkDataList={linkDataList} />
						</div>
					</div>
					<div className="spacer p-[50px]"></div>
					<div className={`${isDesktop ? 'w-[1200px]' : 'p-[10px]'} mx-auto`}>
						{workshop && (
							<>
								<div className="flex-grow">
									<SummarySection workshop={workshop} />
									<div className="spacer p-[10px]"></div>
									<PriceSection workshop={workshop} />
									<div className="spacer p-[100px]"></div>
								</div>
								<div className="spacer p-[10px]"></div>
							</>
						)}
					</div>
					{errorMessage && (
						<div className="text-center font-Vazir-400 text-[#cc0000]">{errorMessage}</div>
					)}
				</div>
				<div className="spacer p-[50px]"></div>
				<div>
					<Footer isDesktop={isDesktop} />
				</div>
			</div>
		</>
	)
}
